<div fxLayout="row" fxLayoutAlign="start ">
  <div fxFlex="1 0 auto">
    <h1>Import Communities</h1>
  </div>

  <div fxFlex="0 0 auto" class="actions">
    <button
      *ngIf="!file; else changeFile"
      mat-flat-button
      [disabled]="loading$ | async"
      (click)="fileInput.click()"
    >
      Select File
    </button>
    <ng-template #changeFile>
      <button
        class="pad"
        mat-stroked-button
        [disabled]="loading$ | async"
        (click)="fileInput.click()"
      >
        Change File
      </button>
      <button
        *ngIf="file"
        mat-flat-button
        [disabled]="loading$ | async"
        (click)="importEvent()"
      >
        Import Communities & Family
      </button>
    </ng-template>
  </div>
</div>
<p>
  Upload a CSV file containing your communities to continue. Family users will
  be invited by email to activate their account.
</p>

<input
  type="file"
  [disabled]="loading$ | async"
  [style.display]="'none'"
  #fileInput
  accept=".csv,.xls,.xlsx"
  (change)="changed()"
/>
<mat-progress-bar
  mode="buffer"
  [value]="(progress$ | async) * 100"
  *ngIf="loading$ | async"
></mat-progress-bar>
<ca-customer-import-preview
  *ngIf="file"
  [config]="preview"
  [loading]="loading$ | async"
  [error]="error$ | async"
  [results]="results$ | async"
  [form]="form"
  [file]="file"
></ca-customer-import-preview>

<p>
  Download
  <a target="_blank" href="./assets/csv/customers.csv"
    >Community CSV template</a
  >
</p>
<p>or <a [routerLink]="['../new']">Create a single community</a></p>
